import React, { useState, useEffect } from 'react';

const Product = (props) => 
{ 
    
  const [products, setProducts] = useState([]);

  const $url = `${process.env.REACT_APP_STRIPE_URL}/products.php?type=product`;

  useEffect(() => {
    fetch($url)
      .then(res => res.json())
      .then(data => setProducts(data));
  }, []);

    

    if (props.lang === "EN") {
        return (<div>  
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
      {products.map(product => {
        // default_price can be null if not set
        const price = product.default_price?.unit_amount
          ? (product.default_price.unit_amount / 100).toFixed(2)
          : "N/A";
        const currency = product.default_price?.currency?.toUpperCase() || "";

        // For payment link: you could have price ID or checkout URL
        const checkoutUrl = `${process.env.REACT_APP_STRIPE_URL}/checkout.php?price_id=${product.default_price?.id}`;

        return (
          <div key={product.id} style={{
            border: "1px solid #ccc",
            padding: "16px",
            width: "200px",
            borderRadius: "8px"
          }}>
            {product.images && product.images[0] && (
              <img
                src={product.images[0]}
                alt={product.name}
                style={{ width: "50px", height: "auto", marginBottom: "12px" }}
              />
            )}
            <h3>{product.name}</h3>
            <p>{product.description}</p>
            <p>
              Price: {price} {currency}
            </p>
            {product.default_price && (
              <a href={checkoutUrl}>
                <button style={{
                  padding: "10px 16px",
                  background: "#6772e5",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}>
                  Buy Now
                </button>
              </a>
            )}
          </div>
        );
      })}
    </div>
</div>);
    } 
    if (props.lang === "RU") {
        return (<div>
             <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
      {products.map(product => {
        // default_price can be null if not set
        const price = product.default_price?.unit_amount
          ? (product.default_price.unit_amount / 100).toFixed(2)
          : "N/A";
        const currency = product.default_price?.currency?.toUpperCase() || "";

        // For payment link: you could have price ID or checkout URL
        const checkoutUrl = `${process.env.REACT_APP_STRIPE_URL}/checkout.php?price_id=${product.default_price?.id}`;


        return (
          <div key={product.id} style={{
            border: "1px solid #ccc",
            padding: "16px",
            width: "200px",
            borderRadius: "8px"
          }}>
            {product.images && product.images[0] && (
              <img
                src={product.images[0]}
                alt={product.name}
                style={{ width: "50px", height: "auto", marginBottom: "12px" }}
              />
            )}
            <h3>{product.name}</h3>
            <p>{product.description}</p>
            <p>
              Price: {price} {currency}
            </p>
            {product.default_price && (
              <a href={checkoutUrl}>
                <button style={{
                  padding: "10px 16px",
                  background: "#6772e5",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer"
                }}>
                  Buy Now
                </button>
              </a>
            )}
          </div>
        );
      })}
    </div>
        </div>);
    }
}
export default Product;
